import { render, staticRenderFns } from "./towerPage2.vue?vue&type=template&id=a59b0ca4&scoped=true&"
import script from "./towerPage2.vue?vue&type=script&lang=js&"
export * from "./towerPage2.vue?vue&type=script&lang=js&"
import style0 from "./towerPage2.vue?vue&type=style&index=0&id=a59b0ca4&scoped=true&lang=css&"
import style1 from "./towerPage2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59b0ca4",
  null
  
)

export default component.exports